<template>
  <el-dialog title="移动文件夹" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false" @close="handleClose">
    <el-form style="text-align: start;" label-width="auto">
      <el-form-item label="选择文件夹">
        <el-tag v-if="parentName" closable type="primary" @close="handleTagClose">
          {{ parentName }}
        </el-tag>
        <el-popover v-else popper-class="xxx" placement="top" width="300" v-model="visible">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="width: 100%"> </el-input>
          <span>提示: 点击三角形按钮展开, 如果点击名字则为选中</span>
          <el-tree class="filter-tree" ref="tree" :data="treeData" :filter-node-method="filterNode"
            @node-click="handleClick" />
          <el-button slot="reference" size="mini" type="primary" plain>选择文件夹</el-button>
        </el-popover>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" plain @click="dialogVisible = false;">取消</el-button>
      <el-button size="mini" type="primary" plain @click="handleSubmit()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from '@/untils/util'
import { postFilesQuertFilesDict } from '../api.js'
export default {
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      projectId: util.session.get('groupId'),
      parentName: '',
      filterText: '',
      treeData: [],
      visible: false,
      praentId: '',
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    async getAllDir() {
      try {
        const { data: res } = await postFilesQuertFilesDict({ projectId: this.projectId })
        if (res.code === 200) {
          this.treeData = res.data
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    handleTagClose() {
      this.parentName = ''
      this.praentId = ''
    },
    handleClick(data) {
      this.praentId = data.id
      this.parentName = data.label
      this.visible = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleClose() {
      this.parentName = ''
      this.praentId = ''
      this.filterText = ''
    },
    handleSubmit() {
      this.$emit('confim', this.praentId)
    },
  },
  watch: {
    dialog(newVal) {
      newVal && this.getAllDir()
    },
    filterText(val) {
      this.$refs.tree?.filter(val)
    },
  },
}
</script>

<style scoped lang="less">
.xxx {
  width: 300px;
  height: 400px !important;
  overflow-y: auto !important;
}

.filter-tree {
  height: 400px !important;
  overflow-y: auto;
}
</style>
